import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import logo from "../img/Logo-BluStay-02.png";
import useCurrency from "../hooks/useCurrency";
import { useAppDispatch, useAppSelector } from "../hooks/hooks";
import logoHome from "../img/logo_home.png";
import { currencyPage } from "../redux/reducers/InformacionReducer";

const TITLES = [
    {
        id: 1,
        title: "Nosotros",
        url: "nosotros",
    },
    {
        id: 2,
        title: "Planes",
        url: "planes",
    },
    {
        id: 3,
        title: "Funcionalidades",
        url: "funcionalidades",
    },
    {
        id: 4,
        title: "Simulador",
        url: "calculadora",
    },
];

const TITLES2 = [
    {
        id: 5,
        title: "Testimonios",
        url: "testimonios",
    },
    {
        id: 6,
        title: "Contáctanos",
        url: "contactanos",
    },
    {
        id: 7,
        title: "Blogs",
        url: "../../blog",
    },
    {
        id: 8,
        title: "Políticas de uso y privacidad",
        url: "politicas-de-uso-y-privacidad",
    },
];

interface Pros {
    calculadora?: string;
    messageWhatsapp?: string;
}

export const Footer = ({ calculadora, messageWhatsapp = "" }: Pros) => {
    const [titleSelected, setTitleSelected] = useState<number>(0);
    const { currency } = useAppSelector((state) => state.informacion);

    const navigate = useNavigate();
    const [selectedCurrency, setSelectedCurrency] = useState<string>("");
    const dispatch = useAppDispatch();
    const { view, tags } = useParams();
    const [linkWhatsapp, setLinkWhatsapp] = useState("");

    const handleSmoothScroll = (title: string) => {
        navigate(`/home/${tags ? tags : "6"}/${title}`);
    };

    const handleChangeCurrency = (
        event: React.ChangeEvent<HTMLSelectElement>
    ) => {
        const selectedValue = event.target.value;
        setSelectedCurrency(selectedValue);
        localStorage.setItem("currency", selectedValue);
        dispatch(currencyPage(selectedValue));
    };

    useEffect(() => {
        setSelectedCurrency(currency);
    }, [currency]);

    useEffect(() => {
        if (messageWhatsapp === "") {
            setLinkWhatsapp(`https://wa.link/kh9mwp`);
        }

        if (messageWhatsapp === "hotel") {
            setLinkWhatsapp(
                `https://api.whatsapp.com/send?phone=51950707924&text=%C2%A1Hola!%20%20%F0%9F%91%8B%20Me%20podr%C3%ADas%20dar%20m%C3%A1s%20informaci%C3%B3n%20de%20la%20prueba%20de%20hotel`
            );
        }
    }, [messageWhatsapp]);

    return (
        <div className={`flex flex-col  text-[#071829]   `}>
            <a
                className="z-50"
                href={linkWhatsapp}
                target="_blank"
                rel="noreferrer"
            >
                <div className="fixed select-none bottom-5 right-5 xs:right-10 bg-[#00BB22] shadow-lg rounded-full p-3 flex justify-center items-center hover:scale-110 transition animate-bounce z-30">
                    <svg
                        className="w-12 h-12 "
                        id="Capa_2"
                        data-name="Capa 2"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 99.76 100"
                    >
                        <g id="Testimonios">
                            <g>
                                <path
                                    fill="white"
                                    d="m0,100l7.17-26.75c-4.06-7.32-6.2-15.53-6.2-23.86C.97,22.16,23.13,0,50.36,0s49.39,22.16,49.39,49.39-22.16,49.39-49.39,49.39c-8.18,0-16.25-2.06-23.48-5.98L0,100Zm28.22-17.23l1.69,1.01c6.22,3.7,13.29,5.66,20.45,5.66,22.09,0,40.06-17.97,40.06-40.06S72.45,9.34,50.36,9.34,10.31,27.3,10.31,49.39c0,7.29,2.03,14.47,5.86,20.77l1.04,1.71-4,14.93,15.02-4.02Z"
                                />
                                <path
                                    fill="white"
                                    d="m68.17,56.26c-2.03-1.22-4.68-2.57-7.07-1.59-1.84.75-3.01,3.63-4.2,5.1-.61.75-1.34.87-2.28.49-6.9-2.75-12.18-7.35-15.99-13.7-.64-.99-.53-1.76.25-2.68,1.15-1.35,2.59-2.89,2.9-4.72.31-1.82-.54-3.96-1.3-5.58-.96-2.08-2.04-5.04-4.12-6.21-1.91-1.08-4.43-.47-6.13.91-2.94,2.39-4.36,6.14-4.31,9.86.01,1.06.14,2.11.39,3.13.59,2.45,1.73,4.74,3,6.92.96,1.64,2.01,3.23,3.13,4.77,3.69,5.01,8.28,9.37,13.59,12.62,2.66,1.63,5.52,3.05,8.48,4.03,3.32,1.1,6.28,2.24,9.87,1.56,3.75-.71,7.46-3.04,8.95-6.66.44-1.07.66-2.27.42-3.4-.51-2.34-3.68-3.73-5.57-4.86Z"
                                />
                            </g>
                        </g>
                    </svg>
                </div>
            </a>

            <div className="flex flex-col items-center justify-center w-full py-5 text-[#071829] lg:py-10">
                <div className="flex flex-col items-start justify-between  mx-auto lg:flex-row w-11/12 md:w-5/6 xl:w-4/5">
                    <span
                        onClick={() => handleSmoothScroll("inicio")}
                        className="inline-block mb-5 font-medium cursor-pointer lg:mr-8 lg:text-lg"
                    >
                        <div className="flex flex-col justify-start items-start">
                            <img src={logoHome} alt="logo blustay" />
                            <div className="text-[#0F80F2] lg:w-60 w-full mt-5 ">
                                Gestionar tu propiedad nunca fue tan fácil.
                            </div>
                        </div>
                    </span>

                    <div className=" gap-1 flex flex-col text-sm lg:text-base text-[#029DE0] ">
                        <div className="mb-2 font-bold">Síguenos</div>

                        <div className="flex lg:flex-row flex-col gap-3">
                            <div className="text-[#071829]">
                                <a
                                    href="https://www.facebook.com/bluustay.io"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Facebook
                                </a>
                            </div>
                            <div className="text-[#071829]">
                                <a
                                    href="https://www.instagram.com/blustay.io/"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Instagram
                                </a>
                            </div>
                            <div className="text-[#071829]">
                                <a
                                    href="https://www.linkedin.com/company/blustay-io/"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Linkedin
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="flex mt-9 lg:flex-row flex-col justify-start items-start lg:gap-7 gap-3 mb-5 text-left text-sm lg:text-base">
                        <div className="font-bold lg:mb-3 text-[#029DE0] ">
                            Contáctanos:
                        </div>

                        <div className="relative text-[#071829]  cursor-pointer select-none">
                            <a
                                className="flex gap-2 lg:justify-center lg:items-center justify-start items-start"
                                href="mailto:ventas@blustay.io"
                            >
                                <svg
                                    width="20"
                                    height="16"
                                    viewBox="0 0 20 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M2.66671 15.3332C2.16254 15.3332 1.73094 15.1537 1.37192 14.7946C1.01289 14.4356 0.833374 14.004 0.833374 13.4998V2.49984C0.833374 1.99567 1.01289 1.56407 1.37192 1.20505C1.73094 0.846018 2.16254 0.666504 2.66671 0.666504H17.3334C17.8375 0.666504 18.2691 0.846018 18.6282 1.20505C18.9872 1.56407 19.1667 1.99567 19.1667 2.49984V13.4998C19.1667 14.004 18.9872 14.4356 18.6282 14.7946C18.2691 15.1537 17.8375 15.3332 17.3334 15.3332H2.66671ZM10 8.9165L2.66671 4.33317V13.4998H17.3334V4.33317L10 8.9165ZM10 7.08317L17.3334 2.49984H2.66671L10 7.08317ZM2.66671 4.33317V2.49984V13.4998V4.33317Z"
                                        fill="#071829"
                                    />
                                </svg>{" "}
                                ventas@blustay.io
                            </a>
                        </div>

                        <div className="relative text-[#071829] capitalize cursor-pointer select-none">
                            <a
                                className="flex gap-2 lg:justify-center lg:items-center justify-start items-start"
                                href="https://wa.me/51950707924"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g clip-path="url(#clip0_238_558)">
                                        <path
                                            d="M13.319 10.3431C13.284 10.3262 11.9717 9.68006 11.7385 9.59614C11.6433 9.56195 11.5413 9.52858 11.4329 9.52858C11.2557 9.52858 11.1068 9.61688 10.9909 9.79034C10.8598 9.98518 10.463 10.449 10.3404 10.5876C10.3244 10.6059 10.3025 10.6277 10.2894 10.6277C10.2777 10.6277 10.0746 10.5441 10.0131 10.5174C8.60542 9.90593 7.53693 8.43549 7.39042 8.18752C7.3695 8.15187 7.36862 8.13568 7.36844 8.13568C7.37359 8.1168 7.42092 8.06935 7.44535 8.04486C7.51683 7.97415 7.59426 7.88093 7.66918 7.79076C7.70466 7.74804 7.74019 7.70526 7.77508 7.66493C7.88378 7.53847 7.93217 7.44028 7.98828 7.32656L8.01767 7.26747C8.15466 6.99531 8.03766 6.76564 7.99985 6.69147C7.96881 6.62941 7.41473 5.29215 7.35582 5.15166C7.21416 4.81264 7.02697 4.65479 6.76685 4.65479C6.74271 4.65479 6.76685 4.65479 6.66563 4.65905C6.54237 4.66425 5.87117 4.75262 5.57441 4.93969C5.2597 5.1381 4.72729 5.77055 4.72729 6.88281C4.72729 7.88386 5.36255 8.82903 5.6353 9.18851C5.64208 9.19756 5.65453 9.21597 5.67259 9.24239C6.71711 10.7678 8.01925 11.8983 9.33927 12.4256C10.6101 12.9333 11.2119 12.9919 11.554 12.9919H11.554C11.6978 12.9919 11.8129 12.9807 11.9144 12.9707L11.9788 12.9645C12.4178 12.9256 13.3825 12.4257 13.602 11.8159C13.7749 11.3355 13.8205 10.8107 13.7054 10.6203C13.6267 10.4908 13.4909 10.4256 13.319 10.3431Z"
                                            fill="#071829"
                                        />
                                        <path
                                            d="M9.15977 0C4.2848 0 0.318727 3.93627 0.318727 8.77459C0.318727 10.3395 0.737519 11.8713 1.53086 13.2119L0.012376 17.6912C-0.0159097 17.7747 0.00512928 17.867 0.066902 17.9299C0.111493 17.9755 0.17198 18 0.233753 18C0.257421 18 0.281266 17.9964 0.304525 17.989L4.97517 16.5048C6.25329 17.1877 7.69785 17.5482 9.15982 17.5482C14.0343 17.5482 18 13.6124 18 8.77459C18 3.93627 14.0343 0 9.15977 0ZM9.15977 15.7204C7.78411 15.7204 6.4517 15.3232 5.30636 14.5716C5.26785 14.5463 5.22314 14.5334 5.17814 14.5334C5.15436 14.5334 5.13051 14.537 5.10731 14.5443L2.7676 15.2881L3.5229 13.0598C3.54733 12.9876 3.53512 12.9081 3.49012 12.8466C2.61793 11.6549 2.15689 10.2469 2.15689 8.77459C2.15689 4.94416 5.29836 1.82782 9.15971 1.82782C13.0206 1.82782 16.1617 4.94416 16.1617 8.77459C16.1618 12.6046 13.0207 15.7204 9.15977 15.7204Z"
                                            fill="#071829"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_238_558">
                                            <rect
                                                width="18"
                                                height="18"
                                                fill="white"
                                            />
                                        </clipPath>
                                    </defs>
                                </svg>{" "}
                                950 707 924
                            </a>
                        </div>
                    </div>
                </div>

                <div className="flex md:flex-row flex-col lg:justify-end lg:items-end justify-start gap-10 items-start w-11/12 md:w-5/6 xl:w-4/5 text-[#071829]  mx-auto lg:-mt-10 mt-5 ">
                    <div
                        onClick={() =>
                            navigate("/home/6/politicas-de-uso-y-privacidad")
                        }
                        className=" cursor-pointer select-none text-sm lg:text-base"
                    >
                        Políticas de uso y privacidad
                    </div>

                    <div
                        onClick={() =>
                            navigate("/home/6/terminos-y-condiciones")
                        }
                        className=" cursor-pointer select-none text-sm lg:text-base"
                    >
                        Términos y condiciones
                    </div>
                </div>
            </div>

            <div className="flex  lg:justify-center justify-start w-11/12 md:w-5/6 mx-auto gap-6 py-5 text-[#029DE0] border-t border-[#029DE0]">
                <div className="text-sm  xs:text-base">
                    <div className="flex lg:text-center text-left ">
                        <p>© Copyright BluStay 2025</p>
                    </div>
                </div>
            </div>
        </div>
    );
};
